import { Component } from '@angular/core';
import { ECommerceService } from '../service/e-commerce.service';
import { ModalComponent } from '../model/modal-component.interface';
import { Subject } from 'rxjs';
import { GadgetViewModel } from '../../../model/view-model/gadget/gadget.view.model';

@Component({
  template: ''
})
export class ProductDetailsComponent implements ModalComponent<GadgetViewModel> {
  product: GadgetViewModel | null = null;
  public quantity: number = 1;
  public onClose = new Subject<{ needsUpdate: boolean; newQuantity: number }>();

  constructor(protected eCommerceService: ECommerceService) {}

  ngAfterViewInit() {
    this.quantity = this.product.quantity;
  }

  ngOnDestroy() {
    this.onClose.complete();
  }

  onChangeQuantity(quantity) {
    if (this.product) {
      this.quantity = quantity;
    }
  }

  onAddToCart(): void {
    if (this.product && this.product.quantity != this.quantity) {
      this.eCommerceService.updatePreOrderItem({
        itemId: this.product.itemId,
        quantity: this.quantity
      });

      this.close(true);
    } else {
      this.close();
    }
  }

  close(needsUpdate: boolean = false) {
    this.onClose.next({ needsUpdate, newQuantity: this.quantity });
    this.eCommerceService.hideDetails();
  }
}
